import gbFlag from "flag-icons/flags/4x3/gb.svg";
import euFlag from "flag-icons/flags/4x3/eu.svg";
import usFlag from "flag-icons/flags/4x3/us.svg";
import caFlag from "flag-icons/flags/4x3/ca.svg";
import auFlag from "flag-icons/flags/4x3/au.svg";
import nzFlag from "flag-icons/flags/4x3/nz.svg";

export const flagSrcMap = {
  gb: gbFlag,
  eu: euFlag,
  us: usFlag,
  ca: caFlag,
  au: auFlag,
  nz: nzFlag,
};

export const productSpecs = [
  "Made from 100% organic ring-spun cotton",
  "Soft, breathable, and built for all-day comfort",
  "Midweight fabric (5.3 oz) with a premium feel",
  "Regular fit with set-in sleeves for easy wear",
  "Ribbed collar and durable double-needle stitching",
  "Self-fabric neck tape for added comfort",
  "GOTS & OCS certified organic cotton",
  "OEKO-TEX® Standard 100 certified and PETA-Approved Vegan",
];

export const productSpecsJumper = [
  "Soft, durable cotton-blend hoodie",
  "100% cotton face for a smooth, premium feel",
  "Midweight fleece (8.5 oz) built for everyday wear",
  "Classic front pouch pocket",
  "Three-panel hood with matching flat drawstrings",
  "Self-fabric patch on the back for a clean finish",
  "Designed for all-day warmth and easy layering",
];

export const productSpecsHat = [
  "100% chino cotton twill",
  "Unstructured, low-profile fit",
  "Six-panel design with embroidered eyelets",
  "Curved visor for a classic look",
  "Adjustable strap with antique buckle",
  "Comfortable, everyday wear",
];

export const productSpecsBeanie = [
  "Soft, snug cuffed beanie",
  "100% turbo acrylic fabric",
  "Warm, form-fitting design",
  "Hypoallergenic and comfortable for all-day wear",
  "Unisex, one-size-fits-most fit",
  "12″ length for classic cuffed style",
  "Hand washable",
];

export const colorOptions = {
  Lavender: "#f7ecff",
  White: "#ffffff",
  Black: "#000000",
  "French Navy": "#112537",
  Khaki: "#6e6b4d",
  "Forest Green": "#222e1f",
  Bone: "#f5e8ce",
  Pink: "#fab2ba",
  Stone: "#d6bdad",
  Navy: "#182031",
  Stargazer: "#3d737d",
  "Desert Dust": "#dcccb4",
  Spruce: "#183a31",
  "Dark Grey": "#39353a",
  "Navy Blazer": "#171f2c",
  "Vintage Black": "#43413D",
  Anthracite: "#3e383e",
  Burgundy: "#801f24",
  "Light Blue": "#b5cbda",
  Charcoal: "#6a6967",
  "Military Green": "#737a5f",
  "Cotton Pink": "#ffe9eb",
  "Fraiche Peche": "#ffd2be",
  "Heather Grey": "#cfcbc8",
  "Dark Heather Grey": "#2b2928",
  "Dark Heather Blue": "#7a8ca8",
  // Add more color mappings as needed
};
